import { ApiResourceBaseClass as i } from "./baseApiCalls.js";
const o = "whatsapp/number", a = "whatsapp/profile";
class c extends i {
  /**
   * Determines whether the User is allowed to onboard using a dedicated phone number.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/whatsapp/number/authorization`
   *
   * @returns {Promise<WhatsappNumberAuthorization>} A promise resolving to the authorization data.
   */
  getNumberAuthorization = async () => {
    const { data: s } = await this.get(`${o}/authorization`);
    return s;
  };
  /**
   * Fetches a Whatsapp profile.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/whatsapp/profile/{whatsapp_phone_number_id}`
   *
   * @param {number} [phone_number_id] - Id of the WhatsappPhoneNumber.
   * @returns {Promise<WhatsappProfileData>} A promise that resolves to the profile data.
   */
  getProfile = async (s) => {
    const { data: t } = await this.get(`${a}/${s}`);
    return t;
  };
  /**
   * Creates or updates a WhatsappPhoneNumber's WhatsappConversationReengageSettings.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/api/v2/whatsapp/profile/{whatsapp_phone_number_id}/conversation-reengage-settings`
   *
   * @param {number} [phone_number_id] - Id of the WhatsappPhoneNumber.
   * @param {ConversationReengageSettingsFormValues} [settings] - WhatsappConversationReengageSettings fields.
   * @returns {Promise<WhatsappConversationReengageSettings>} A promise that resolves to the created/updated WhatsappConversationReengageSettings.
   */
  postConversationReengageSettings = async (s, t) => {
    const { data: n } = await this.post(
      `${a}/${s}/conversation-reengage-settings`,
      t
    );
    return n;
  };
  /**
   * Updates the businesses that carry the selected WhatsappPhoneNumber's number as attribute.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/api/v2/whatsapp/profile/{whatsapp_phone_number_id}/business-diffusion`
   *
   * @param {number} [phone_number_id] - Id of the WhatsappPhoneNumber.
   * @param {BusinessModalFiltersType} [businessSearchFilter] - Business modal filters to select the businesses.
   * @returns {Promise<WhatsappSuccessResponse>} A promise that resolves to a success payload.
   */
  postBusinessDiffusion = async (s, t) => {
    const n = {
      business_search_params: t
    }, { data: e } = await this.post(
      `${a}/${s}/business-diffusion`,
      n
    );
    return e;
  };
  /**
   * Lists all the businesses that already carry the selected WhatsappPhoneNumber's number as an attribute.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/whatsapp/profile/{whatsapp_phone_number_id}/business-diffusion`
   *
   * @param {number} [phone_number_id] - Id of the WhatsappPhoneNumber.
   * @returns {Promise<WhatsappGetDiffusionBusinessListData>} A promise that resolves to a list of business_ids.
   */
  getBusinessDiffusion = async (s) => {
    const { data: t } = await this.get(
      `${a}/${s}/business-diffusion`
    );
    return t;
  };
}
export {
  c as WhatsappProfile
};
